import { ArtistCredit, artistCreditsFromJson } from '../artistList/artist';

export class Album {
    private id: number;
    private title: string;
    private releaseDate: string;
    private coverArtPath: string;
    private mbid: string;
    private primaryType: string;
    private secondaryType: string;
    private genres: string;
    private artists: ArtistCredit[];

    constructor(
        id: number,
        title: string,
        releaseDate: string,
        coverArtPath: string,
        mbid: string,
        primaryType: string = '',
        secondaryType: string = '',
        genres: string = '',
        artists: ArtistCredit[] = []
    ) {
        this.id = id;
        this.title = title;
        this.releaseDate = releaseDate;
        this.coverArtPath = coverArtPath;
        this.mbid = mbid;
        this.primaryType = primaryType;
        this.secondaryType = secondaryType;
        this.genres = genres;
        this.artists = artists;
    }

    public getId(): number {
        return this.id;
    }

    public getTitle(): string {
        return this.title;
    }

    public getReleaseDate(): string {
        return this.releaseDate;
    }

    public getReleaseYear(): string {
        return this.releaseDate ? this.releaseDate.slice(0, 4) : '';
    }

    public getCoverArtPath(): string {
        return this.coverArtPath;
    }

    public getMbid(): string {
        return this.mbid;
    }

    public getPrimaryType(): string {
        return this.primaryType;
    }

    public getSecondaryType(): string {
        return this.secondaryType;
    }

    // Comma-joined genre list as stored (e.g. "Rock, Hard Rock") - empty
    // when no provider had genre data for this album.
    public getGenres(): string {
        return this.genres;
    }

    // Combined release-type label for display (e.g. "EP", "Live, Compilation
    // Album") - MusicBrainz's secondary types (Live, Compilation, ...) are
    // qualifiers on the primary type, not a replacement for it.
    public getReleaseTypeLabel(): string {
        if (!this.primaryType) return '';
        return this.secondaryType ? `${this.secondaryType} ${this.primaryType}` : this.primaryType;
    }

    /** Every artist credited on this album (collaborations/compilations included). */
    public getArtists(): ArtistCredit[] {
        return this.artists;
    }

    public static fromJson(json: any): Album {
        return new Album(
            json.id,
            json.title,
            json.release_date ?? '',
            json.cover_art_path ?? '',
            json.mbid ?? '',
            json.primary_type ?? '',
            json.secondary_type ?? '',
            json.genres ?? '',
            artistCreditsFromJson(json.artists)
        );
    }
}
